module.exports = __webpack_public_path__ + "static/first-94a1acaf9f8c9e6751144a2196f831e8.jpg";